import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const requestPackagingAgreement = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [
    ["user"],
    ["dossier", dossierId],
    ["dossierStatus", dossierId],
  ];

  return useMutation({
    mutationFn: (): Promise<string> => {
      return fetchWithAuth<string>("requestPackagingAgreement", dossierId, {
        requestOptions: { method: "post" },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
  });
};
